import {Component} from 'react';
import h from 'react-hyperscript';
import * as d3 from 'd3';
import {unMountD3} from 'Src/utils/utils';
import {setZeroIfInvalidNumber} from 'Src/utils/utils';

class ProgressBar extends Component {
  constructor(props) {
    super(props);
    this.createProgressBar = this.createProgressBar.bind(this);
    this.height = props.height;
    this.width = '100%';
    this.className = `chart bar-chart__container progress-bar__container
        ${props.className ? props.className : ''}`;
    this.backgroundColor = '#e8eaed';
  }

  componentDidMount() {
    this.createProgressBar();
  }

  componentDidUpdate(prevProps) {
    if (this.props.value !== prevProps.value) {
      this.createProgressBar();
    }
  }

  componentWillUnmount() {
    unMountD3(this.node, d3);
  }

  createProgressBar() {
    const node = this.node;
    const scale = d3.scaleLinear()
        .domain([0, 1])
        .range([0, '100%']);

    const svg = d3.select(node);
    const value = setZeroIfInvalidNumber(this.props.value);

    svg.append('rect')
        .attr('class', 'progress__rect-bg')
        .attr('rx', 4)
        .attr('ry', 4)
        .attr('fill', this.backgroundColor)
        .attr('height', this.height)
        .attr('width', this.width)
        .attr('x', 0);

    svg.append('rect')
        .attr('class', 'progress__rect')
        .attr('fill', this.props.color)
        .attr('height', this.height)
        .attr('width', 0)
        .attr('rx', 4)
        .attr('ry', 4)
        .attr('x', 0)
        .attr('width', (d) => scale(value));
  }

  render() {
    return (
      h('div', {
        className: this.className,
        id: this.props.id,
      },
      h('svg', {
        ref: (node) => this.node = node,
        width: this.width,
        height: this.height,
      })
      )
    );
  }
}

export default ProgressBar;
